import React, { useEffect, useState } from 'react'
import { withRouter, Link } from 'react-router-dom'
import { Badge, Col, Popover, Row, Spin, Avatar, message } from 'antd'
import {
  fetchUnreadNotifications,
  clearScoutNotifications,
} from '../../../redux/scoutFlowControl/scoutFlowControlActions'
import ProfileToggle from '../../../pages/ScoutPortal/ScoutProfile/components/ProfileToggle'
import { useDispatch, useSelector } from 'react-redux'
import CopyToClipboard from 'react-copy-to-clipboard'
import moment from 'moment'
import Logo from '../../../assets/images/scouts/exitfund_logo.jpg'
import Bell from '../../../assets/images/scouts/bell.svg'
import empty_notification_icon from '../../../assets/images/scouts/empty_notification_icon.svg'
import copyClipboard from '../../../assets/images/scouts/copyClipboard.svg'
import './Header.scss'

// Mobile header component for the Scout section.
const HeaderScoutMobile = ({ history }) => {
  const dispatch = useDispatch()
  const profileData = useSelector(state => state?.scoutflowControl?.profile_data)
  const unread_notification_count = useSelector(state => state?.scoutflowControl?.unread_notification_count)
  const unreadNotifications = useSelector(state => state?.scoutflowControl?.unreadNotifications)
  const [unread, setUnread] = useState(0)

  // Update the unread notification count.
  useEffect(() => {
    setUnread(unread_notification_count)
  }, [unread_notification_count])

  /**
   * Handles the visibility change of the notification popover.
   *
   * @param {boolean} visibility - Popover visibility.
   */
  const VisibleChangeHandler = visiblity => {
    if (!visiblity) {
      setUnread(0)
    }
  }

  // Handles the click event for the notification icon.
  const onNotificationClick = () => {
    dispatch(fetchUnreadNotifications())
  }

  // Handles the click event to clear all notifications.
  const onClearNotification = () => {
    dispatch(clearScoutNotifications())
  }

  // Notification popover content.
  const notifications = (
    <div className="notifications-content-wrapper">
      {false ? (
        <Spin />
      ) : (
        <>
          <div className="pop-header">
            <h4>Notification</h4>
            <span className="clear-all" onClick={onClearNotification}>
              Clear all
            </span>
          </div>
          <div className="pop-content">
            {unreadNotifications?.map(item => (
              <div className="line-hr">
                <Row gutter={12}>
                  <Col span={4}>
                    <div className="alignments">
                      <Avatar src={item?.profile_pic}>{item?.first_name?.[0]?.toUpperCase() || 'N'}</Avatar>
                    </div>
                  </Col>
                  <Col span={18}>
                    <div className="alignments">
                      <span className="notification-msg">{item?.activity}</span>
                      <span className="timing">{moment(item?.timestamp).utc(true).fromNow()}</span>
                    </div>
                  </Col>
                </Row>
              </div>
            ))}
          </div>
          <div className="pop-footer">
            <span
              onClick={() => {
                setUnread(0)
                history.push('/scout/notifications')
              }}
            >
              View All
            </span>
          </div>
        </>
      )}
    </div>
  )

  // Empty notification popover content.
  const emptyNotificationContent = (
    <div className="empty-scout-nootification-content-wrap">
      <div className="pop-header">
        <h4>Notification</h4>
        <span className="clear-all" onClick={() => history.push('/scout/notifications')}>
          View all
        </span>
      </div>
      <div className="pop-content">
        <img src={empty_notification_icon} alt="" />
        <span className="no-notification-text">No new notifications</span>
      </div>
    </div>
  )

  return (
    <div className="header-mobile m-0">
      <div className="logo" id="home-logo">
        <Link to="/scout/invite">
          <img className="logo-img" src={Logo} alt="Logo - Exitfund" />
        </Link>
      </div>
      <div className="d-flex justify-content-end align-items-center w-100">
        {profileData?.invite_code && (
          <div className="invite-code-wrap mr-3 ">
            <span>{profileData?.invite_code || ''}</span>
            <CopyToClipboard
              text={profileData?.invite_code}
              onCopy={() => message.success('Copied to clipboard')}
            >
              <img role="button" className="ml-3" src={copyClipboard} alt="" />
            </CopyToClipboard>
          </div>
        )}

        {unreadNotifications?.length > 0 ? (
          <Popover
            arrowContent={null}
            content={notifications}
            placement="bottomRight"
            trigger="click"
            onVisibleChange={visiblity => VisibleChangeHandler(visiblity)}
          >
            <Badge count={unread} onClick={() => onNotificationClick()} className="mr-3">
              <img src={Bell} alt="" />
            </Badge>
          </Popover>
        ) : (
          <Popover
            arrowContent={null}
            content={emptyNotificationContent}
            placement="bottomRight"
            trigger="click"
            onVisibleChange={visiblity => VisibleChangeHandler(visiblity)}
          >
            <Badge count={unread} className="mr-3" onClick={() => onNotificationClick()}>
              <img src={Bell} alt="" />
            </Badge>
          </Popover>
        )}
        <ProfileToggle profileData={profileData} />
      </div>
    </div>
  )
}

export default withRouter(HeaderScoutMobile)
